module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAIklEQVR4AWMYNOA/OXg4GfAfiEjGg8yAM0ABkvHwMGB4AAC51ie0NIHtlwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/DE.png
// module id = 1122
// module chunks = 0